const STORAGE_KEY = 'demohub_tasks';

export const COLUMNS = {
  backlog: { id: 'backlog', title: 'Backlog', icon: '📥' },
  todo: { id: 'todo', title: 'To Do', icon: '📋' },
  inprogress: { id: 'inprogress', title: 'In Progress', icon: '⚡' },
  review: { id: 'review', title: 'Review', icon: '🔍' },
  done: { id: 'done', title: 'Done', icon: '✅' },
};

export const PRIORITIES = {
  urgent: { label: 'Urgent', color: '#ff4757', icon: '🔴' },
  high: { label: 'High', color: '#ff6b35', icon: '🟠' },
  medium: { label: 'Medium', color: '#ffd32a', icon: '🟡' },
  low: { label: 'Low', color: '#0be881', icon: '🟢' },
};

export const LABELS = [
  { id: 'bug', name: 'Bug', color: '#ff4757' },
  { id: 'feature', name: 'Feature', color: '#7c83ff' },
  { id: 'improvement', name: 'Improvement', color: '#00d2d3' },
  { id: 'design', name: 'Design', color: '#e040fb' },
  { id: 'docs', name: 'Docs', color: '#ffd32a' },
  { id: 'devops', name: 'DevOps', color: '#ff6b35' },
];

const defaultTasks = [
  {
    id: '1',
    title: 'Design landing page mockups',
    description: 'Create high-fidelity mockups for the new landing page including hero section, features, and pricing.',
    column: 'done',
    priority: 'high',
    labels: ['design'],
    createdAt: Date.now() - 86400000 * 5,
    subtasks: [
      { id: 's1', text: 'Hero section', done: true },
      { id: 's2', text: 'Features grid', done: true },
      { id: 's3', text: 'Pricing cards', done: true },
    ],
  },
  {
    id: '2',
    title: 'Set up CI/CD pipeline',
    description: 'Configure GitHub Actions for automated testing and deployment to staging environment.',
    column: 'review',
    priority: 'urgent',
    labels: ['devops'],
    createdAt: Date.now() - 86400000 * 3,
    subtasks: [
      { id: 's4', text: 'Configure build step', done: true },
      { id: 's5', text: 'Add test runner', done: true },
      { id: 's6', text: 'Deploy to staging', done: false },
    ],
  },
  {
    id: '3',
    title: 'Implement user authentication',
    description: 'Add JWT-based authentication with login, register, and password reset flows.',
    column: 'inprogress',
    priority: 'urgent',
    labels: ['feature'],
    createdAt: Date.now() - 86400000 * 2,
    subtasks: [
      { id: 's7', text: 'Login form', done: true },
      { id: 's8', text: 'Register form', done: false },
      { id: 's9', text: 'Password reset', done: false },
    ],
  },
  {
    id: '4',
    title: 'Fix responsive navbar collapse',
    description: 'The navigation menu does not collapse properly on mobile devices below 480px width.',
    column: 'todo',
    priority: 'high',
    labels: ['bug'],
    createdAt: Date.now() - 86400000,
    subtasks: [],
  },
  {
    id: '5',
    title: 'Add dark mode support',
    description: 'Implement a theme toggle that switches between light and dark color schemes across the app.',
    column: 'todo',
    priority: 'medium',
    labels: ['feature', 'design'],
    createdAt: Date.now() - 86400000,
    subtasks: [
      { id: 's10', text: 'Create theme context', done: false },
      { id: 's11', text: 'Update color variables', done: false },
      { id: 's12', text: 'Add toggle button', done: false },
    ],
  },
  {
    id: '6',
    title: 'Write API documentation',
    description: 'Document all REST endpoints with request/response examples using Swagger.',
    column: 'backlog',
    priority: 'low',
    labels: ['docs'],
    createdAt: Date.now(),
    subtasks: [],
  },
  {
    id: '7',
    title: 'Optimize image loading',
    description: 'Implement lazy loading and WebP format support for all product images.',
    column: 'backlog',
    priority: 'medium',
    labels: ['improvement'],
    createdAt: Date.now(),
    subtasks: [],
  },
  {
    id: '8',
    title: 'Refactor payment module',
    description: 'Extract payment processing logic into a dedicated service with proper error handling.',
    column: 'inprogress',
    priority: 'high',
    labels: ['improvement', 'feature'],
    createdAt: Date.now() - 86400000 * 1,
    subtasks: [
      { id: 's13', text: 'Extract service', done: true },
      { id: 's14', text: 'Add error handling', done: false },
      { id: 's15', text: 'Write unit tests', done: false },
    ],
  },
];

export function loadTasks() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return JSON.parse(saved);
  } catch (e) {
    console.error('Failed to load tasks:', e);
  }
  return defaultTasks;
}

export function saveTasks(tasks) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tasks));
  } catch (e) {
    console.error('Failed to save tasks:', e);
  }
}
